import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import LogicBaseFeaturedApi from '../server/LogicBaseFeaturedApi';

class LogicBaseFeaturedCache extends ObjectCache {
  api = LogicBaseFeaturedApi;

  createObject = (_results) => JSON.parse(JSON.stringify(_results));

  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    if (!results) return;
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
}

const singleton = new LogicBaseFeaturedCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
